import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const BatchActionModalContent: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="px-8">
			<div>
				<div className="mb-5">
					{t('PENDING_PAYOUTS.MODAL_TEXT_POST')}
				</div>
				<div className="mb-5">
					{t('PENDING_PAYOUTS.MODAL_MAIN_TEXT_POST')}
				</div>
				<div>
					<span className="fw-bolder me-2">Note:</span>
					{t('PENDING_PAYOUTS.MODAL_TEXT_POST_NOTE')}
				</div>
			</div>
		</div>
	);
};